import * as React from 'react';

import Modal from 'react-modal';
import { connect, Dispatch } from 'react-redux';
import { InjectedRouter } from 'react-router';
import { bindActionCreators } from 'redux';

// @ts-ignore
import PIIConsentModal from 'app/components/PIIConsentModal';
import { withRouter } from 'app/context/Router';
import LoadingModal from 'components/LoadingModal';
import LinkConstants from 'constants/LinkConstants';
import { showToast } from 'reducers/toasts';
// @ts-ignore
import UserActions from 'user/UserActions';

type Props = {
  router: InjectedRouter;
  location: any;
  showToast: Function;
};

type State = {
  working: boolean;
};

class SetupPIIConsent extends React.Component<Props, State> {
  state: State = {
    working: false,
  };

  handleOnConsentGiven = () => {
    this.setState({ working: true });

    UserActions.loadCurrentUser().then(
      () => this.props.router.push(this.props.location?.state?.location ?? '/'),
      (error: Error) => {
        console.debug(error);
        this.setState({ working: false });
        console.error('SetupPIIConsent: could not reload user');
        this.props.showToast('An error occured, please try again.', 'error');
      }
    );
  };

  handleOnConsentRefused = () => {
    window.location = LinkConstants.MARKETING;
  };

  handleOnConsentGivenError = (error: Error) => {
    console.debug(error);
    console.error('SetupPIIConsent: could not record agreement');
    this.props.showToast('An error occured, we could not record your consent.', 'error');
  };

  handleOnConsentRefusedError = (error: Error) => {
    console.debug(error);
    console.error('SetupPIIConsent: could not record agreement refusal');
    this.props.showToast('An error occured, we could not record your refusal.', 'error');
  };

  render() {
    return (
      <Modal isOpen>
        {this.state.working ? (
          <LoadingModal />
        ) : (
          <PIIConsentModal
            data-test="pii-consent-modal"
            onConsentGiven={this.handleOnConsentGiven}
            onConsentRefused={this.handleOnConsentRefused}
            onConsentGivenError={this.handleOnConsentGivenError}
            onConsentRefusedError={this.handleOnConsentRefusedError}
          />
        )}
      </Modal>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return bindActionCreators({ showToast }, dispatch);
}

export { SetupPIIConsent };
export default withRouter(
  connect(
    undefined,
    mapDispatchToProps
    // @ts-ignore
  )(SetupPIIConsent)
);
